import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

export default (ctx, inject) => {
  inject('fancybox', {
    show(slides, options) {
      return Fancybox.show(slides, options)
    },
    bind(container, selector, options) {
      Fancybox.bind(container, selector, options)
      if (options.id) {
        return Fancybox.getInstance({ id: options.id })
      }
    },
    next() {
      return Fancybox.next()
    },
    prev() {
      return Fancybox.prev()
    },
    getSlide() {
      return Fancybox.getSlide()
    },
    unbind(container) {
      return Fancybox.unbind(container)
    },
    close() {
      return Fancybox.close()
    },
    destroy() {
      return Fancybox.destroy()
    }
  })
}
